import { createAction } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import { State, Callback } from './types';

export const fetchGroups = createAction('groups/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedGroups = createAction('groups/fetched', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  fetchGroups,
  fetchedGroups,
};
